import { render, staticRenderFns } from "./socialFilter.vue?vue&type=template&id=195dc3d3&scoped=true&"
import script from "./socialFilter.vue?vue&type=script&lang=js&"
export * from "./socialFilter.vue?vue&type=script&lang=js&"
import style0 from "./socialFilter.vue?vue&type=style&index=0&id=195dc3d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195dc3d3",
  null
  
)

export default component.exports